import Activities, { ActivityPayload } from '@/components/Activities'
import Paper from '@/components/Paper'
import { getServiceUpdates } from '@/modules/Service/services'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Typogaphy } from 'vnetwork-ui'

const ServiceUpdates = () => {
    const { id: serviceID } = useParams()
    const { t } = useTranslation('services')

    const wrappedApiCall = ({ page, page_size }: ActivityPayload) =>
        getServiceUpdates({
            serviceID: Number(serviceID),
            payload: {
                page,
                page_size,
            },
        })

    return (
        <Paper>
            <Typogaphy className="text-sm font-medium text-gray-700 mb-2">
                {t('activity_logs.title')}
            </Typogaphy>
            <Activities
                apiCall={wrappedApiCall}
                queryKey={`services.${serviceID}.actions`}
            />
        </Paper>
    )
}

export default ServiceUpdates
